import script from "./ModalOrderSearchMemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOrderSearchMemo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOrderSearchMemo.vue?vue&type=style&index=0&id=53850a98&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53850a98"]])

export default __exports__